module.exports = __webpack_public_path__ + "static/img/Stephen_Coniglio_desktop.c45f0fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Stephen_Coniglio_desktop.jpg
// module id = Zime
// module chunks = 0